<h2 mat-dialog-title>Add Case</h2>
<mat-dialog-content class="mat-typography">
  <sn-form [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" type="button" (click)="close()">Cancel</button>
  <button mat-button color="success" type="submit" (click)="submit()" cdkFocusInitial>Save</button>
</mat-dialog-actions>
